import { render, staticRenderFns } from "./SupBaseInfo.vue?vue&type=template&id=0ad080e9&"
import script from "./SupBaseInfo.vue?vue&type=script&lang=js&"
export * from "./SupBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupBaseInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports